import { useEffect, useState } from 'react'
import { INITIAL_INTERNAL_TEAMS, type InternalTeam } from '../data/internalTeams'

/**
 * Shared store for internal teams: edited in Configurer, read by the
 * notice audience ("Qui") and the audience estimate.
 */
let teams: InternalTeam[] = INITIAL_INTERNAL_TEAMS
const listeners = new Set<(next: InternalTeam[]) => void>()

export function getInternalTeams(): InternalTeam[] {
  return teams
}

export function setInternalTeams(next: InternalTeam[]) {
  teams = next
  listeners.forEach((listener) => listener(next))
}

export function useInternalTeams(): InternalTeam[] {
  const [value, setValue] = useState(teams)
  useEffect(() => {
    listeners.add(setValue)
    setValue(teams)
    return () => {
      listeners.delete(setValue)
    }
  }, [])
  return value
}
